module.exports = __webpack_public_path__ + "static/media/rcmd.d727ddb6.png";